import SumoSimulationInfo from "@/plugin/gis-viewer/widgets/SumoSimulation/SumoSimulationInfo.vue";
import { IResult, ISumoConnectInfo, IVehicleTrack } from "@/types/map";
import { loadModules } from "esri-loader";
import $ from "jquery";
import { Vue } from "vue-property-decorator";
import SumoWebWorker from "worker-loader!@/plugin/gis-viewer/workers/sumo.worker";
import VehicleGraphicPool from "./VehicleGraphicPool";

export default class SimulationController {
  private static intances: Map<string, SimulationController>;

  private view!: __esri.SceneView | __esri.MapView;
  private vehicleLayer!: __esri.GraphicsLayer;
  private personLayer!: __esri.GraphicsLayer;

  private Graphic!: __esri.GraphicConstructor;
  private vehicleGraphicMap: Map<string, __esri.Graphic> = new Map();

  /** 显示仿真信息的vue组件 */
  private sumoInfoVue!: any;
  private simulationWorker!: SumoWebWorker;

  private initialized = false;
  private isWebSocketConnected = false;
  private watchZoomEvent!: __esri.WatchHandle | undefined;
  private rafHandle: number | undefined;

  private randomHaloVehicleHandle!: number;
  private randomHaloVehicleTimer = 0;
  private nextRandomHaloVehicleTime = 0;
  private spawnHalo = false;

  // private signalPhaseController!: SignalPhaseController;
  // private startSignalState: boolean = false;
  // private crossId: string = "";

  // 小型车车辆模型
  private smallModels = [
    { href: "obj/BMW_3-Series.glb", width: 2.05, height: 1.43, depth: 4.6 },
    { href: "obj/Ford_Edge.glb", width: 1.95, height: 2, depth: 4.48 },
    { href: "obj/Ford_Fiesta.glb", width: 2.29, height: 2.01, depth: 4.46 },
    {
      href: "obj/Ford_Focus_Hatchback.glb",
      width: 1.95,
      height: 1.89,
      depth: 4.41,
    },
    {
      href: "obj/Ford_Transit_Commercial_Van.glb",
      width: 2,
      height: 1.84,
      depth: 4.32,
    },
    { href: "obj/Toyota_Prius.glb", width: 2.02, height: 1.56, depth: 4.42 },
    { href: "obj/Ford_Mustang.glb", width: 2.05, height: 1.42, depth: 4.75 },
    { href: "obj/Audi_A6.glb", width: 2.04, height: 1.46, depth: 4.88 },
    {
      href: "obj/Volkswagen_Jetta_Wagon.glb",
      width: 2.17,
      height: 1.65,
      depth: 4.77,
    },
    {
      href: "obj/Ford_Transit_Connect.glb",
      width: 2.35,
      height: 2.2,
      depth: 4.84,
    },
    { href: "obj/Ford_Expedition.glb", width: 2.31, height: 1.95, depth: 4.91 },
    { href: "obj/Ford_Fusion.glb", width: 2.14, height: 1.69, depth: 4.99 },
  ];
  // 中型车车辆模型
  private mediumModels = [
    { href: "obj/Ford_Taurus.glb", width: 2.24, height: 1.63, depth: 5.14 },
    {
      href: "obj/Mercedes_S-Class.glb",
      width: 2.24,
      height: 1.58,
      depth: 5.35,
    },
  ];
  // 大型车车辆模型
  private largeModels = [
    { href: "obj/Bus.glb", width: 3.07, height: 3.84, depth: 12 },
  ];

  private smallPool!: VehicleGraphicPool;
  private mediumPool!: VehicleGraphicPool;
  private largePool!: VehicleGraphicPool;

  private constructor(view: __esri.SceneView | __esri.MapView) {
    this.view = view;
    // if (this.view.type == "3d") {
    //   this.signalPhaseController = SignalPhaseController.getInstance(
    //     this.view as __esri.SceneView
    //   );
    // }
  }

  public static getInstance(view: __esri.SceneView | __esri.MapView) {
    const id = view.container.id;
    if (!SimulationController.intances) {
      SimulationController.intances = new Map();
    }
    let instance = this.intances.get(id);
    if (!instance) {
      instance = new SimulationController(view);
      SimulationController.intances.set(id, instance);
    }
    return instance;
  }

  private async initialize() {
    type MapModules = [
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/Graphic")
    ];
    const [GraphicsLayer, Graphic] = await (loadModules([
      "esri/layers/GraphicsLayer",
      "esri/Graphic",
    ]) as Promise<MapModules>);

    // this.startSignalState = false;
    this.Graphic = Graphic;
    this.vehicleLayer = new GraphicsLayer();
    this.personLayer = new GraphicsLayer();
    this.view.map.addMany([this.vehicleLayer, this.personLayer]);

    const sumoInfoConstructor = Vue.extend(SumoSimulationInfo);
    this.sumoInfoVue = new sumoInfoConstructor();
    const containerId = this.view.container.id;
    $("<div/>", { id: `divSumoSimulationInfo_${containerId}` }).appendTo(
      `#${containerId}Widget`
    );
    this.sumoInfoVue.$mount(`#divSumoSimulationInfo_${containerId}`);

    this.simulationWorker = new SumoWebWorker();

    this.simulationWorker.onmessage = (event: MessageEvent) => {
      this.onReceiveWorkerMessage(event.data);
    };

    this.initialized = true;
  }

  private initVehicleModelPool() {
    this.smallPool = new VehicleGraphicPool(
      this.smallModels,
      this.Graphic,
      this.vehicleLayer,
      30
    );
    this.mediumPool = new VehicleGraphicPool(
      this.mediumModels,
      this.Graphic,
      this.vehicleLayer,
      10
    );
    this.largePool = new VehicleGraphicPool(
      this.largeModels,
      this.Graphic,
      this.vehicleLayer,
      5
    );
  }

  public async connectSumoSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    if (!this.initialized) {
      await this.initialize();
    }
    // this.crossId = params.crossId;
    if (!this.isWebSocketConnected) {
      this.simulationWorker.postMessage({
        type: "connectSumoSimulation",
        data: {
          url: params.url,
          guid: params.guid,
        },
      });

      // let _this = this;
      this.watchZoomEvent = this.view.watch("zoom", (newValue, oldValue) => {
        // _this.simulationWorker.postMessage({
        //   type: "updateSimulationinterval",
        //   data: {
        //     zoom: this.view.zoom,
        //   },
        // });
        if (
          (oldValue < 20 && newValue >= 20) ||
          (oldValue >= 20 && newValue < 20)
        ) {
          this.change2DVehiclSymbol();
        }
      });

      return { status: 0, message: "SumoSimulation start successful" };
    } else {
      return { status: 0, message: "SumoSimulation has already connected" };
    }
  }

  public disconnectSumoSimulation() {
    if (this.simulationWorker) {
      this.simulationWorker.postMessage({
        type: "disconnectSumoSimulation",
      });
      this.vehicleLayer.removeAll();
      this.vehicleGraphicMap.clear();
      // this.sumoInfoVue.stopSimulation();
      if (this.watchZoomEvent) {
        this.watchZoomEvent.remove();
        this.watchZoomEvent = undefined;
      }
    }
  }

  public async connectRealTimeSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    if (!this.initialized) {
      await this.initialize();
    }

    if (!this.isWebSocketConnected) {
      if (this.view.type === "3d") {
        this.initVehicleModelPool();
        setTimeout(() => {
          this.simulationWorker.postMessage({
            type: "connectRealTimeSimulation",
            data: {
              url: params.url,
            },
          });
        }, 3000);
      } else {
        this.simulationWorker.postMessage({
          type: "connectRealTimeSimulation",
          data: {
            url: params.url,
          },
        });

        this.watchZoomEvent = this.view.watch("zoom", (newValue, oldValue) => {
          if (
            (oldValue < 20 && newValue >= 20) ||
            (oldValue >= 20 && newValue < 20)
          ) {
            this.change2DVehiclSymbol();
          }
        });
      }

      return { status: 0, message: "RealTimeSimulation connect successful" };
    } else {
      return { status: 0, message: "RealTimeSimulation has already connected" };
    }
  }

  public disconnectRealTimeSimulation() {
    if (this.simulationWorker) {
      this.simulationWorker.postMessage({
        type: "disconnectRealTimeSimulation",
      });
      this.vehicleLayer.removeAll();
      this.personLayer.removeAll();

      this.smallPool?.destroy();
      this.mediumPool?.destroy();
      this.largePool?.destroy();
    }
    // if (this.signalPhaseController) {
    //   this.signalPhaseController.stopSignalPhase(this.crossId);
    // }
    // this.startSignalState = false;
    if (this.watchZoomEvent) {
      this.watchZoomEvent.remove();
      this.watchZoomEvent = undefined;
    }
    clearInterval(this.randomHaloVehicleHandle);
  }

  private tracksWaitForUpdate: Array<IVehicleTrack> = [];

  /** 处理worker回传数据 */
  private onReceiveWorkerMessage(data: any) {
    switch (data.type) {
      // sumo车辆新增、位置更新
      case "sumoVehicleUpdated": {
        const newVehicles: Array<IVehicleTrack> = data.data.newVehicles;
        const existVehicles: Array<IVehicleTrack> = data.data.existVehicles;

        if (!this.view.interacting) {
          this.addNewVehicles(newVehicles);
          // this.updateVehiclesPosition(existVehicles);
          this.tracksWaitForUpdate = this.tracksWaitForUpdate.concat(
            existVehicles
          );
        }
        break;
      }

      // sumo车辆抵达
      case "sumoVehicleDelete":
        this.deleteVehicles(data.data);
        break;

      // 实时仿真车辆更新--增、删、改
      case "realTimeVehicleUpdated": {
        const newVehicles: Array<IVehicleTrack> = data.data.newVehicles;
        const existVehicles: Array<IVehicleTrack> = data.data.existVehicles;
        const deleteVehicles: Array<string> = data.data.deleteVehicles;
        const persons: Array<IVehicleTrack> = data.data.persons;
        // const dataTimeStamp = data.data.dataTimeStamp;
        // AppModule.setSumoStartTime(dataTimeStamp);
        // if (!this.startSignalState) {
        //   this.startSignalPhase();
        // }

        this.addNewVehicles(newVehicles, "real");
        this.updateVehiclesPosition(existVehicles, "real");
        if (persons && persons.length > 0) {
          this.updatePersonsPosition(persons);
        }
        if (deleteVehicles && deleteVehicles.length > 0) {
          this.deleteRealTimeVehicles(deleteVehicles);
        }

        this.sumoInfoVue.$props.vehicleCount = this.vehicleLayer.graphics.length;
        break;
      }

      // websocket连接打开成功
      case "sumoSimulationConnectOpen":
        this.isWebSocketConnected = true;
        this.rafHandle = requestAnimationFrame(() => {
          this.updateVehiclesPositionInFrame();
        });
        break;

      case "realTimeSimulationConnectOpen":
        this.isWebSocketConnected = true;

        this.randomHaloVehicleTimer = 0;
        this.nextRandomHaloVehicleTime = Math.floor(Math.random() * 10 + 5);
        this.randomHaloVehicleHandle = setInterval(() => {
          this.randomHaloVehicleTimer++;
          if (this.randomHaloVehicleTimer === this.nextRandomHaloVehicleTime) {
            this.spawnHalo = true;

            this.randomHaloVehicleTimer = 0;
            this.nextRandomHaloVehicleTime = Math.floor(Math.random() * 5 + 5);
          }
        }, 1000);
        break;

      // websocket连接关闭
      case "sumoSimulationConnectClose":
        if (this.rafHandle) {
          cancelAnimationFrame(this.rafHandle);
          this.rafHandle = undefined;
        }
        this.isWebSocketConnected = false;
        break;

      case "realTimeSimulationConnectClose":
        this.isWebSocketConnected = false;
        break;
    }
  }
  // private startSignalPhase() {
  //   let crossId: string = this.crossId;
  //   this.startSignalState = true;
  //   this.signalPhaseController.setSignalPhase({
  //     showCenter: false,
  //     crossId,
  //   } as any);
  // }

  private addNewVehicles(
    tracks: Array<IVehicleTrack>,
    trackType: string = "sumo"
  ) {
    const addGraphics: Array<__esri.Graphic> = [];
    tracks.forEach((track) => {
      let graphic = new this.Graphic({
        geometry: {
          type: "point",
          longitude: track.x,
          latitude: track.y,
        } as any,
      });

      if (trackType === "sumo") {
        graphic.symbol = this.get2DVehicleSymbol(track);
        graphic.attributes = track;
        graphic.attributes["type"] = "sumo-details";
        addGraphics.push(graphic);
        this.vehicleGraphicMap.set(track.id, graphic);
      } else if (trackType === "real" && this.view.type === "2d") {
        // 随机出现网联车图标
        if (this.spawnHalo) {
          this.spawnHalo = false;
          const haloGraphic = new this.Graphic({
            geometry: graphic.geometry,
            symbol: {
              type: "picture-marker",
              url: "assets/image/highlight.png",
              width: "60px",
              height: "60px",
            } as any,
          });

          addGraphics.push(haloGraphic);
          this.vehicleGraphicMap.set(track.id + "-halo", haloGraphic);
        }

        graphic.symbol = this.get2DVehicleSymbol(track);
        graphic.attributes = track;
        graphic.attributes["type"] = "sumo-details";

        // graphic.popupTemplate = {
        //   title: "{id}",
        //   content:
        //     "速度: {speed}km/h<br>坐标: {x}, {y}<br>位置: <br>角度: {angle}",

        //   actions: [
        //     {
        //       title: "详细信息",
        //       id: "sumo-details",
        //       className: "esri-icon-table",
        //     },
        //   ],
        // } as any;

        addGraphics.push(graphic);
        this.vehicleGraphicMap.set(track.id, graphic);
      } else {
        switch (track.size) {
          case "medium":
            graphic = this.mediumPool.fetch();
            break;
          case "large":
            graphic = this.largePool.fetch();
            break;
          default:
            graphic = this.smallPool.fetch();
            break;
        }
        const symbol = (graphic.symbol as __esri.PointSymbol3D).clone();
        const symbolLayer = symbol.symbolLayers.getItemAt(
          0
        ) as __esri.ObjectSymbol3DLayer;
        symbolLayer.heading = (track.angle || 0) + 90;
        graphic.symbol = symbol;
        graphic.geometry = {
          type: "point",
          longitude: track.x,
          latitude: track.y,
        } as any;
        addGraphics.push(graphic);
        this.vehicleGraphicMap.set(track.id, graphic);

        // 显示车牌号
        if (track.showName && track.showName !== "") {
          const labelGraphic = new this.Graphic({
            geometry: {
              type: "point",
              longitude: track.x,
              latitude: track.y,
              z: 3,
            } as any,
            symbol: {
              type: "text",
              text: track.showName,
              color: "white",
              haloColor: track.plateColor,
              haloSize: 1,
              font: {
                size: 12,
                weight: "bold",
              },
            } as any,
          });
          addGraphics.push(labelGraphic);
          this.vehicleGraphicMap.set(track.id + "-label", labelGraphic);
        }
      }
    });
    this.vehicleLayer.addMany(addGraphics);
  }

  private updateVehiclesPosition(
    tracks: Array<IVehicleTrack>,
    trackType: string = "sumo"
  ) {
    tracks.forEach((track) => {
      const id = track.id;
      const graphic = this.vehicleGraphicMap.get(id);
      if (graphic) {
        graphic.attributes.speed = track.speed;
        graphic.attributes.x = track.x;
        graphic.attributes.y = track.y;
        graphic.attributes.angle = track.angle;

        graphic.geometry = {
          type: "point",
          longitude: track.x,
          latitude: track.y,
        } as any;
        // 实时仿真需要修改车头角度
        if (trackType === "sumo") {
          const newGraphic = graphic.clone();
          newGraphic.symbol = this.get2DVehicleSymbol(track);

          this.vehicleGraphicMap.set(id, newGraphic);
          this.vehicleLayer.remove(graphic);
          this.vehicleLayer.add(newGraphic);
        } else if (this.view.type === "2d") {
          const symbol = graphic.symbol as __esri.PictureMarkerSymbol;
          symbol.angle = track.angle || 0;

          const haloGraphic = this.vehicleGraphicMap.get(id + "-halo");
          if (haloGraphic) {
            haloGraphic.geometry = graphic.geometry;
          }
        } else {
          const symbol = (graphic.symbol as __esri.PointSymbol3D).clone();
          const symbolLayer = symbol.symbolLayers.getItemAt(
            0
          ) as __esri.ObjectSymbol3DLayer;
          symbolLayer.heading = (track.angle || 0) + 90;
          graphic.symbol = symbol;

          const labelGraphic = this.vehicleGraphicMap.get(id + "-label");
          // 已经有车牌号
          if (labelGraphic) {
            // 车牌号改变
            if (
              (labelGraphic.symbol as __esri.TextSymbol).text !== track.showName
            ) {
              labelGraphic.symbol = {
                type: "text",
                text: track.showName,
                color: "white",
                haloColor: track.plateColor,
                haloSize: 1,
                font: {
                  size: 12,
                  weight: "bold",
                },
              } as any;
            }

            labelGraphic.geometry = {
              type: "point",
              longitude: track.x,
              latitude: track.y,
              z: 3,
            } as any;
          }
          // 原来没有车牌，现在又识别出了车牌
          else if (track.showName && track.showName !== "") {
            const labelGraphic = new this.Graphic({
              geometry: {
                type: "point",
                longitude: track.x,
                latitude: track.y,
                z: 3,
              } as any,
              symbol: {
                type: "text",
                text: track.showName,
                color: "white",
                haloColor: track.plateColor,
                haloSize: 1,
                font: {
                  size: 12,
                  weight: "bold",
                },
              } as any,
            });
            this.vehicleLayer.add(labelGraphic);
            this.vehicleGraphicMap.set(id + "-label", labelGraphic);
          }
        }
      }
    });
  }

  private updatePersonsPosition(tracks: Array<IVehicleTrack>) {
    this.personLayer.removeAll();
    const graphics = tracks.map((track) => {
      const graphic = new this.Graphic({
        geometry: {
          type: "point",
          longitude: track.x,
          latitude: track.y,
        } as any,
        symbol: {
          type: "simple-marker",
          style: "circle",
          color: "white",
          size: "8px",
          outline: {
            color: "black",
            width: 1,
          },
        } as any,
        attributes: track,
      });
      return graphic;
    });
    this.personLayer.addMany(graphics);
  }

  private updateVehiclesPositionInFrame() {
    if (this.tracksWaitForUpdate.length > 0) {
      const tracks = this.tracksWaitForUpdate.splice(0, 100);
      tracks.forEach((track) => {
        const id = track.id;
        const graphic = this.vehicleGraphicMap.get(id);
        if (graphic) {
          graphic.geometry = {
            type: "point",
            longitude: track.x,
            latitude: track.y,
          } as any;
          graphic.attributes["angle"] = track.angle;
          const symbol = graphic.symbol;
          if (symbol.type === "picture-marker") {
            (symbol as __esri.PictureMarkerSymbol).angle = track.angle || 0;
          }
        }
      });
    }

    this.rafHandle = requestAnimationFrame(() => {
      this.updateVehiclesPositionInFrame();
    });
  }

  private deleteVehicles(ids: Array<string>) {
    const deleteGraphics: Array<__esri.Graphic> = [];
    ids.forEach((id) => {
      const graphic = this.vehicleGraphicMap.get(id);
      if (graphic) {
        deleteGraphics.push(graphic);
        this.vehicleGraphicMap.delete(id);
      }
      // const labelGraphic = this.vehicleGraphicMap.get(id + "-label");
      // if (labelGraphic) {
      //   deleteGraphics.push(labelGraphic);
      //   this.vehicleGraphicMap.delete(id + "-label");
      // }
    });
    this.vehicleLayer.removeMany(deleteGraphics);
  }

  private deleteRealTimeVehicles(ids: string[]) {
    const deleteGraphics: Array<__esri.Graphic> = [];
    ids.forEach((id) => {
      const graphic = this.vehicleGraphicMap.get(id);
      if (graphic) {
        graphic.attributes["spawned"] = false;
        graphic.geometry = {
          type: "point",
          x: 0,
          y: 0,
        } as any;
        this.vehicleGraphicMap.delete(id);
      }
      const labelGraphic = this.vehicleGraphicMap.get(id + "-label");
      if (labelGraphic) {
        deleteGraphics.push(labelGraphic);
        this.vehicleGraphicMap.delete(id + "-label");
      }
      const haloGraphic = this.vehicleGraphicMap.get(id + "-halo");
      if (haloGraphic) {
        deleteGraphics.push(haloGraphic);
        this.vehicleGraphicMap.delete(id + "-halo");
      }
    });
    this.vehicleLayer.removeMany(deleteGraphics);
  }

  private get2DVehicleSymbol(track: IVehicleTrack) {
    let symbol: any;
    if (this.view.zoom >= 20) {
      symbol = {
        type: "picture-marker",
        url: "assets/mapIcons/" + track.icon,
        width: 32,
        height: 32,
        angle: track.angle || 0,
      };
    } else {
      symbol = {
        type: "simple-marker",
        style: "circle",
        color: track.color || "red",
        size: "6px",
        outline: {
          color: [255, 0, 0],
          width: 0,
        },
      };
    }

    return symbol;
  }

  private change2DVehiclSymbol() {
    this.vehicleLayer.graphics.forEach((graphic) => {
      const track: IVehicleTrack = graphic.attributes;
      graphic.symbol = this.get2DVehicleSymbol(track);
    });
  }

  private centerGraphic!: __esri.Graphic;
  private setCenterHandle!: number;

  public focusOnVehicle(id: string) {
    if (this.centerGraphic) {
      const track: IVehicleTrack = this.centerGraphic.attributes;
      track.color = "red";
      track.icon = "car-top-red.png";
      this.centerGraphic.symbol = this.get2DVehicleSymbol(track);
    }

    const graphic = this.vehicleGraphicMap.get(id);
    if (graphic) {
      const track: IVehicleTrack = graphic.attributes;
      track.color = "#2196f3";
      track.icon = "car-top-blue.png";
      graphic.symbol = this.get2DVehicleSymbol(track);
      this.centerGraphic = graphic;

      this.setCenterHandle = setInterval(() => {
        this.setVehicleInCenter();
      }, 1000);
    }
  }

  public cancelFocus() {
    clearInterval(this.setCenterHandle);
    if (this.centerGraphic) {
      const track: IVehicleTrack = this.centerGraphic.attributes;
      track.color = "red";
      track.icon = "car-top-red.png";
      this.centerGraphic.symbol = this.get2DVehicleSymbol(track);
    }
  }

  private setVehicleInCenter() {
    if (this.centerGraphic) {
      this.view.center = this.centerGraphic.geometry as __esri.Point;
    }
  }
}
